import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var GenrateDiseaseRes;
export const GenrateDiseaseTodo = createAsyncThunk('GenrateDisease', async (data) => {
    console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'admin/generate_disease_report',
            data: data,
            headers: { "Content-Type": "application/json",  "Authorization": 'Bearer ' + localStorage.getItem('user_token')}
        })
        return GenrateDiseaseRes = res.data
        
    } catch (error) {
        return GenrateDiseaseRes = error.response.data
    }
})